import React from 'react';
import Header from './components/Header';
import Form from './components/Form';

const Login: React.FC = () => {
  return (
    <div className="w-px-400 mx-auto pt-5 pt-lg-0">
      <Header />
      <Form />
    </div>
  );
};

export default Login;
